import { isEmptyValue, sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import Registry from '@/routers/views/registry/registry';
import { REGISTRY_TABLE_FIELDS_LIBRARY, USER_TYPE, REGISTRY_TYPE } from '@/utils/constants';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { sessionService } from '@/providers/services/auth/session';
import { registryAPI } from '@/providers/apis/registry/registry';

@Component({
    name: 'tool-registry',
    components: {
        Registry,
    },
})

export default class ToolRegistry extends Vue {
    // -----------------------------------------------------------
    // Properties

    private providerList: any = [];

    private filterList: any = [];

    private searchTerms: string = '';
    private tableFields: any = [];

    private registryType: string = REGISTRY_TYPE.toolRegistry;

    private title: string = 'Tool Registry';

    private userType: string = '';

    private providerLogo: any = '';
    private totalCount: any = 0;
    private contentPerPgae: any = 10;
    private closePullUp: boolean = false;
    private tenantId: string = '';
    private selectedFilter: any = {};
    private isDistrictUser: boolean = false;

    private isSuperUser: boolean = false;

    private isContentProvider: boolean = false;

    private isLoading: boolean = false;

    // ---------------------------------------------------------
    // Hooks
    private created() {
        this.userType = this.$access.getUserType();
        this.tenantId = this.$access.getTenantId();
        this.isDistrictUser = this.userType === USER_TYPE.districtUser;
        this.isSuperUser = this.$access.hasAllPermission;
        this.isContentProvider = this.userType === USER_TYPE.contentProvider;
        this.tableFields = (this.isSuperUser) ? REGISTRY_TABLE_FIELDS_LIBRARY.superUserTool
            : (this.isContentProvider)
                ? REGISTRY_TABLE_FIELDS_LIBRARY.contentProviderTool : REGISTRY_TABLE_FIELDS_LIBRARY.districtUserTool;
        const paggination = {
            offset: 0,
            limit: this.contentPerPgae,
            search_terms: this.searchTerms,
        };
        this.fetchProvidersList(paggination);
    }

    private onSearchItemsText(value: any) {
        this.searchTerms = value;
        this.onSelectPage(0);
    }


    // ------------------------------------------------------------------------
    // Methods

    private fetchProvidersList(paggination: any) {
        this.isLoading = true;
        registryAPI.fetchToolRegistryList(paggination, this.tenantId).then((data: any) => {
            this.isLoading = false;
            const providerData = data.providers;
            sortByProperty(providerData, 'toolDetails.name', 'ASC');
            this.totalCount = data.totalCount;
            this.providerList = providerData;
            this.filterList = providerData;
        });
    }

    private showDeatils(details: any) {
        this.$store.dispatch('partnerDataStore/passSelectedData', details);
        this.$router.push({
            path: `${this.$router.currentRoute.path}/${details.id}`,
        });
    }

    private showHeaderDeatils(details: any) {
        this.$router.push({
            path: `${this.$router.currentRoute.path}/${this.providerList[0].id}`,
        });
    }

    private onEnableAccess(item: any) {
        const content = item;
    }

    private onSelectPage(offsetLimit: any) {
        const selectedFilter = this.selectedFilter || {};
        const params = {
            offset: offsetLimit,
            limit: this.contentPerPgae,
            search_terms: this.searchTerms,
        };
        if (Object.keys(selectedFilter).length) {
            this.parseFilterBody(params);
        }
        this.fetchProvidersList(params);
    }

    private onApplyFilter(filterList: any) {
        this.selectedFilter = filterList;
        this.onSelectPage(0);
    }

    private parseFilterBody(params: any) {
        const { category, audience, subject, grades, toolCateogry } = this.selectedFilter;
        params.category = category.length ? category.toString() : null;
        params.subject = subject.length ? subject.toString() : null;
        params.grades = grades.length ? grades.toString() : null;
        params.audience = audience.length ? audience.toString() : null;
        params.tool_category = toolCateogry.length ? toolCateogry.toString() : null;
    }

}
